import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { User, UserService } from './core/services/user/user.service'

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'angular-base';
  user: User | null = null;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.user = this.userService.getUser(); 
  }
}
